var map = {
	"./BF_1.svg": 856,
	"./BF_4.svg": 398,
	"./BF_Hardline.svg": 911,
	"./BF_V.svg": 722,
	"./career.svg": 58,
	"./help.svg": 441,
	"./news.svg": 190,
	"./quit.svg": 536,
	"./watch.svg": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;